import { render } from "./SampleReportsTab.vue?vue&type=template&id=2450134d"
import script from "./SampleReportsTab.vue?vue&type=script&lang=js"
export * from "./SampleReportsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__